import { memo } from 'react';
import { bool, array, object, string, func, oneOfType } from 'prop-types';
import Button from './Button';
import { tomorrow, dayAfterTomorrow, formattedTomorrow, formattedDayAfterTomorrow } from '../../../../../helpers/next-date-helper';
import DateHelper, { DateFormatters } from '../../../../../helpers/date-helper';
import * as Styled from './Style';
import { capitalize } from '../../../../../helpers/text-helper';
const Overlay = ({
  allDaysOnClick = Function.prototype,
  onCloseModal = Function.prototype,
  selectedDays,
  onSelectedDate,
  isShownControls,
  scheduleBasePath
}) => {
  const formattedSelectedDays = DateHelper.format(selectedDays, DateFormatters.Date);
  const onClick = day => {
    onSelectedDate(day, true);
    onCloseModal();
  };
  const tomorrowDateBtn = /*#__PURE__*/React.createElement(Button, {
    onClick: () => onClick(tomorrow),
    title: capitalize(I18n.t('components.OrderTimer.tomorrow')),
    isDisabled: formattedSelectedDays === formattedTomorrow
  });
  const afterTomorrowDateBtn = /*#__PURE__*/React.createElement(Button, {
    onClick: () => onClick(dayAfterTomorrow),
    title: capitalize(I18n.t('components.OrderTimer.day_after_tomorrow')),
    isDisabled: formattedSelectedDays === formattedDayAfterTomorrow
  });
  const allDaysDateBtn = /*#__PURE__*/React.createElement(Button, {
    onClick: allDaysOnClick,
    title: I18n.t('layout.search.form.all_days'),
    isHidden: !scheduleBasePath
  });
  return isShownControls && /*#__PURE__*/React.createElement(Styled.Overlay, {
    className: "datepicker-overlay"
  }, tomorrowDateBtn, afterTomorrowDateBtn, allDaysDateBtn);
};
Overlay.propTypes = {
  allDaysOnClick: func,
  selectedDays: oneOfType([array, object]),
  isShownControls: bool,
  scheduleBasePath: string,
  onSelectedDate: func,
  onCloseModal: func
};
export default /*#__PURE__*/memo(Overlay);